// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__22ZqS","inputWrap":"styles_inputWrap__2BaoI","input":"styles_input__3Sc2A"};